import { skipToken } from '@reduxjs/toolkit/query/react';
import { type AskAllTrailsArgs, getAskAllTrailsError, useAskAllTrailsQuery } from '@/utils/askAllTrailsApi';

/**
 * One submitted Ask AllTrails question and its response. Every reader passes the args stored at submit time, so they get the
 * same object, and RTK Query makes one request and hands them all the same response.
 *
 * Asking again is a new submission, never a `refetch()`, so `isFetching` only ever means the submitted question is in flight.
 */
const useAskTurn = (args: AskAllTrailsArgs | undefined) => {
  // `currentData`, not `data`: `data` keeps the previous question's response while a new one loads.
  const { currentData, error, isFetching } = useAskAllTrailsQuery(args ?? skipToken);

  return {
    error: error ? getAskAllTrailsError(error) : undefined,
    isFetching,
    page: currentData,
    request: args?.request,
    requestId: args?.requestId
  };
};

export default useAskTurn;
